import { useEffect, useState } from "react"

import { RadioGroup, Text } from "ui-kit/components-branded/index"
import { Icon } from "components"
import { setPayByCard } from "modules/Booking/FormPage/common"
import {
    CurrencySelectorBooking,
    CardItem,
    CardItemAnother,
    Discounts,
    CardOneItem,
} from "modules/BookingCommon/components"
import { useGetClientPaymentMethods } from "modules/ClientAccount/hooks"
import { useFormPageContext } from "modules/Booking/FormPage/common/FormPageContext"
import { useBookingContext } from "modules/Booking/BookingContext"
import { useSkipPayment } from "modules/Booking/FormPage/common/hooks"
import { CURRENCY } from "utils/constants"
import { SESSION_TYPE } from "modules/Booking/common/constants"
import { TimeRequestSelectors } from "modules/Booking/common/interfaces"
import { useOnlyFreeSessions } from "pages/FreePsysPage/useOnlyFreeSessions"
import * as utils from "utils/utils"
import { formatToyLd } from "utils/datetime-format-utils"

interface Props {
    hasPreviousSessions: boolean
    onBeforeApplyDiscount: () => boolean
}

function getDateIfSameMonth(requestTimesSelectors: TimeRequestSelectors[]) {
    const first_date = new Date(`${requestTimesSelectors[0].date} ${requestTimesSelectors[0].time}`)
    if (
        requestTimesSelectors.some((item) => {
            const itemDate = new Date(`${item.date} ${item.time}`)
            return (
                itemDate.getMonth() !== first_date.getMonth() ||
                itemDate.getFullYear() !== first_date.getFullYear()
            )
        })
    )
        return undefined
    return formatToyLd(first_date)
}

export function PaymentMethodsBlock({ onBeforeApplyDiscount, hasPreviousSessions }: Props) {
    const [{ form }, { dispatch }] = useFormPageContext()
    const { data: cards = [] } = useGetClientPaymentMethods()
    const [
        {
            currency,
            psy,
            selectedTime,
            selectedService,
            selectedDiscount,
            sessionType,
            requestTimesSelectors,
        },
        { setCurrency, setSelectedDiscount, setCanChangeHistory },
    ] = useBookingContext()

    const onlyFree = useOnlyFreeSessions()
    const skipPayment = useSkipPayment()
    const [isEdit, toggleIsEdit] = useState(false)

    useEffect(() => {
        if (cards.length > 0) {
            dispatch(setPayByCard(cards[0]))
        }
    }, [cards])
    const date =
        requestTimesSelectors.length === 0 ||
        requestTimesSelectors.some((item) => item.date === undefined)
            ? utils.formatUtcDateIso(selectedTime)
            : getDateIfSameMonth(requestTimesSelectors)
    return (
        <div className="booking-form">
            {!skipPayment && (
                <>
                    <div className="booking-form__title-wrapper">
                        <Text className="mgb-4 is-inline-block" isAccent>
                            Способ оплаты
                        </Text>
                        {!isEdit && cards.length > 0 && (
                            <Icon
                                type="edit"
                                size={19}
                                className="cursor-pointer"
                                onClick={() => toggleIsEdit(true)}
                            />
                        )}
                    </div>
                    {cards.length === 0 && (
                        <CurrencySelectorBooking currency={currency} onChange={setCurrency} />
                    )}
                    {cards.length > 0 && !isEdit && <CardOneItem card={form.payByCard} />}
                    {cards.length > 0 && isEdit && (
                        <>
                            <CurrencySelectorBooking currency={currency} onChange={setCurrency} />
                            {currency === CURRENCY.RUB && (
                                <div className="booking-form__card-list">
                                    <RadioGroup>
                                        {cards.map((item) => (
                                            <CardItem
                                                card={item}
                                                payExternalId={form.payByCard?.external_id}
                                                onChange={(card) => dispatch(setPayByCard(card))}
                                                key={item.external_id}
                                            />
                                        ))}
                                        <CardItemAnother
                                            payByCard={form.payByCard}
                                            onChange={() => dispatch(setPayByCard(null))}
                                            key={0}
                                        />
                                    </RadioGroup>
                                </div>
                            )}
                        </>
                    )}
                </>
            )}
            {!onlyFree && sessionType !== SESSION_TYPE.DEPOSIT && (
                <>
                    {!skipPayment && <hr className="booking-form__discount-divider" />}
                    <Discounts
                        hasPreviousSessions={hasPreviousSessions}
                        email={form.email}
                        psy={psy}
                        date={date}
                        selectedService={selectedService}
                        selectedDiscount={selectedDiscount}
                        onBeforeAddDiscount={onBeforeApplyDiscount}
                        onChangeDiscount={setSelectedDiscount}
                        onCanChangeHistory={setCanChangeHistory}
                    />
                </>
            )}
        </div>
    )
}
